import { render, staticRenderFns } from "./SurveyNominations.vue?vue&type=template&id=ec721ee8&lang=html&"
import script from "./SurveyNominations.vue?vue&type=script&lang=js&"
export * from "./SurveyNominations.vue?vue&type=script&lang=js&"
import style0 from "./SurveyNominations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports